import React, { useState, useEffect } from "react";
import MainSlider from '../components/MainSlider';
import CompanyDetails from '../components/CompanyDetails';
import FoundersDetails from '../components/FoundersDetails';
import ProductSlider from '../components/ProductSlider';
import MainScrollText from '../components/MainScrollText';
import ServiceSlider from '../components/ServiceSlider';
import Aspirations from '../components/Aspirations';
import ContactUs from '../components/ContactUs';
import useStore from '../context/store';
import { getProducts } from '../api/productApi'; // Import API functions
import { getServices } from '../api/serviceApi'; // Import API functions
import { CircularProgress, Alert, Box, Typography } from "@mui/material"; // For loading/error

function Home() {
  const data = useStore((state) => state);
  const [products, setProducts] = useState([]);
  const [services, setServices] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [loadingServices, setLoadingServices] = useState(true);
  const [error, setError] = useState(null);

  // Fetch Products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoadingProducts(true);
        setError(null);
        const response = await getProducts();
        setProducts(response.data);
      } catch (err) {
        console.error("Home - Fetch Products Error:", err);
        setError(err.response?.data?.message || "Failed to fetch products.");
      } finally {
        setLoadingProducts(false);
      }
    };
    fetchProducts();
  }, []);

  // Fetch Services
  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoadingServices(true);
        setError(null); // Reset error potentially set by product fetch
        const response = await getServices();
        setServices(response.data);
      } catch (err) {
        console.error("Home - Fetch Services Error:", err);
        setError(err.response?.data?.message || "Failed to fetch services.");
      } finally {
        setLoadingServices(false);
      }
    };
    fetchServices();
  }, []);

  return (
    <div className="App overflow-x-hidden">
      <MainSlider data={data.store.homeData.slides} />
      <CompanyDetails data={data.store.homeData.companyDetails} />
      <FoundersDetails data={data.store.homeData.foundersDetails} />

      {/* Product Slider Section */}
      <Box sx={{ minHeight: "300px", position: "relative" }}>
        {" "}
        {/* Added wrapper for loading/error */}
        {loadingProducts && (
          <CircularProgress
            sx={{
              position: "absolute",
              top: "40%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          />
        )}
        {error && !products.length && (
          <Alert severity="error" sx={{ m: 2 }}>
            {error}
          </Alert>
        )}
        {!loadingProducts && products.length > 0 && (
          <ProductSlider
            data={products}
            heading={data.store.homeData.productsSliderHeading}
          />
        )}
        {!loadingProducts && !error && products.length === 0 && (
          <Typography sx={{ textAlign: "center", p: 4 }}>
            No products found.
          </Typography>
        )}
      </Box>

      <MainScrollText data={data.store.homeData.mainScrollText} />

      {/* Service Slider Section */}
      <Box sx={{ minHeight: "300px", position: "relative" }}>
        {" "}
        {/* Added wrapper for loading/error */}
        {loadingServices && (
          <CircularProgress
            sx={{
              position: "absolute",
              top: "40%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          />
        )}
        {error && !services.length && (
          <Alert severity="error" sx={{ m: 2 }}>
            {error}
          </Alert>
        )}
        {!loadingServices && services.length > 0 && (
          <ServiceSlider
            data={services}
            heading={data.store.homeData.serviceSliderHeading}
          />
        )}
        {!loadingServices && !error && services.length === 0 && (
          <Typography sx={{ textAlign: "center", p: 4, color: "white" }}>
            No services found.
          </Typography> // Added check for empty services
        )}
      </Box>
      <Aspirations
        data={data.store.homeData.aspirations}
        image={data.store.homeData.aspirationsbg}
      />
      <ContactUs data={data.store.homeData.contactUs} />
    </div>
  );
}

export default Home